import { ArrowBackIcon, ArrowForwardIcon } from '@chakra-ui/icons'
import { Button, HStack } from '@chakra-ui/react'
import { Link, useLocation } from 'react-router-dom'
import useReportDocId from '../hooks/useReportDocId'
import useReportCompletionCheck from '../hooks/useReportCompletionCheck'

export default () => {
  const location = useLocation()
  const parts = location.pathname.split('/')
  const step = parseInt(parts[3])
  const month = useReportDocId()

  // Automatically check for completion whenever this component is rendered
  useReportCompletionCheck(month)

  //TODO: Make step a prop?
  let previousUrl = `/report/${parts[2]}/${step - 1}`
  let previousText = 'Previous'

  if (step === 1) {
    previousUrl = '/'
    previousText = 'Dashboard'
  }

  return (
    <HStack spacing={2}>
      <Link to={previousUrl}>
        <Button
          colorScheme='gray'
          size='sm'
          variant='outline'
          leftIcon={<ArrowBackIcon />}
        >
          {previousText}
        </Button>
      </Link>
      <Button size='sm' type='submit' rightIcon={<ArrowForwardIcon />}>
        Yes, OK
      </Button>
    </HStack>
  )
}
